// angular
// 	.module("HeroPRO")
// 	.factory("DealTypeFactory", dealTypeFactory);

import _ from 'lodash';

/* @ngInject */
export default function dealTypeFactory(HPConfig, $http, $rootScope) {
    let _availableDealTypes = {}; // _availableDealTypes[Purchase] and _availableDealTypes[Lease]
    let _selectedDealType = {}; // This object may look different depending on the selected deal type

    return {
        getSelectedDealType,
        setSelectedDealType,
        getAvailableDealTypes,
        fetchAvailableDealTypes,
        submitSelectedDealType,
        hasLeaseDealType,
        hasDirectPayDealType,
        resetDealType,
    };

    function getSelectedDealType() {
    // Get the selected deal type from the factory
        return _selectedDealType;
    }

    function setSelectedDealType(newDealType) {
    // Set the _selectedDealType in the factory
        angular.copy(newDealType, _selectedDealType);
    }

    function getAvailableDealTypes(category) {
    // Get the available deal types from the factory
        if (category === undefined) {
            return _availableDealTypes;
        }

        return _availableDealTypes[category];
    }

    function fetchAvailableDealTypes(params) {
    // Fetch available deal types from the API
        return $http.get(`${HPConfig.heroProApi}Loan/DealTypeOptions`, { params }).then((response) => {
            _availableDealTypes = response.data.Data;
        });
    }

    function submitSelectedDealType(dealTypeData) {
    // Submit the selected deal type along with all pertinent data to the API
        return $http.post(`${HPConfig.heroProApi}Loan/FundingRequest/DealType`, dealTypeData).then((response) => {
            setSelectedDealType(response.data.Data.DealType);
            $rootScope.$broadcast('DealTypeSubmitted', response.data.Data);
        });
    }

    function hasLeaseDealType() {
    // Function that returns whether any lease deal type is available
        return _availableDealTypes.Lease !== undefined;
    }

    function hasDirectPayDealType() {
    // Function that returns whether direct pay deal type is available
        const directPayDealType = _.find(_availableDealTypes.Purchase, purchaseDealType => purchaseDealType.DealTypeId === 3);

        return directPayDealType !== undefined;
    }

    function resetDealType() {
    // Reset the deal type factory
        _availableDealTypes = [];
        _selectedDealType = {};
    }
}



// WEBPACK FOOTER //
// ./src/app/appDetail/addProducts/dealType/dealTypeFactory.js